function f(e, n) {
  for (var l = -1, t = e == null ? 0 : e.length; ++l < t && n(e[l], l, e) !== !1; )
    ;
  return e;
}
export {
  f as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/_arrayEach.js
// module id = 1459
// module chunks = 67